import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './FadeIn';
import { NavBar } from './NavBar';
import { useLanguage } from './LanguageContext';

const serviceCardImages = [
  'https://uasupporters.com/wp-content/uploads/2023/03/Legal-Service-Firms-Top-Banner-1.jpg',
  'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1559526324-593bc073d938?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1529074963764-98f45c47344b?auto=format&fit=crop&w=1400&q=80',
];

const categoryImagesMap = {
  legal: [
    'https://images.unsplash.com/photo-1541447271487-09612b3f49f7?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2t5JTIwc2NyYXBlcnN8ZW58MHx8MHx8fDA%3D', // corporate formation / office building
    'https://www.wheelhouseit.com/wp-content/uploads/2024/04/lawlap.jpeg', // real estate & construction law
    'https://images.unsplash.com/photo-1681505512385-8b9d567a56c0?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTV8fGNvbnRyYWN0fGVufDB8fDB8fHww', // commercial contracts / handshake
    'https://portal.alnozom.sa/pluginfile.php/820/course/overviewfiles/HR.jpeg', // employment & HR law
    'https://plus.unsplash.com/premium_photo-1661329930662-19a43503782f?w=500&auto=format&fit=crop&q=60', // intellectual property / verified
    'https://images.unsplash.com/photo-1627518788331-b3b7fdaa382f?q=80&w=1025&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // litigation / legal documents
    'https://plus.unsplash.com/premium_photo-1694476607280-57d5dc52e766?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fCVEOSU4MiVEOCVBNyVEOSU4NiVEOSU4OCVEOSU4NiUyMCVEOCVBNyVEOSU4NCVEOCVCOSVEOSU4NSVEOSU4NHxlbnwwfHwwfHx8MA%3D%3D', // private client / family office
  ],
  accounting: [
    'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80', // accounting / bookkeeping
    'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1400&q=80', // taxation / charts
    'https://images.unsplash.com/photo-1434626881859-194d67b2b86f?auto=format&fit=crop&w=1400&q=80', // financial planning
    'https://www.investmentbankingcouncil.org/images/investing-in-technology.jpg', // funding & growth
    'https://www.mashvisor.com/blog/wp-content/uploads/2018/06/bigstock-Businessman-Is-Deeply-Reviewin-237430927-1.jpg', // specialized / professional
  ],
  financing: [
    'https://plus.unsplash.com/premium_photo-1661768507909-f961fcff0d45?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGFydG5lcnNoaXB8ZW58MHx8MHx8fDA%3D', // letters of credit / international trade
    'https://www.vakifkatilim.com.tr/documents/SigortaveKurumsalCozumler/teminatmektuplari1140x760urundetay.jpg', // letters of guarantee / documents
    'https://www.evest.blog/wp-content/uploads/2024/07/shutterstock_2286572337-scaled.jpg', // trade finance advisory
    'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1400&q=80', // import/export / shipping
    'https://www.guptasen.com/wp-content/uploads/2020/09/private-money-lenders-Property-India.jpg', // risk management
    'https://plus.unsplash.com/premium_photo-1683120972279-87efe2ba252f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjV8fHRlY2hub2xvZ3l8ZW58MHx8MHx8fDA%3D', // digital trade finance
  ],
  marketing: [
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1400&q=80',
  ],
  immigration: [
    'https://images.unsplash.com/photo-1504214208698-ea1916a2195a?auto=format&fit=crop&w=1400&q=80', // passport / citizenship
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1400&q=80', // golden visa / Dubai skyline
    'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1400&q=80', // startup / entrepreneur
    'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80', // professional / skilled migration
    'https://plus.unsplash.com/premium_photo-1661496148632-514dd2197691?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjl8fGNvbnRyYWN0c3xlbnwwfHwwfHx8MA%3D%3D', // legal / documents
    'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80', // relocation / new home
  ],
  feasibility: [
    'https://insightss.co/blogs/wp-content/uploads/2024/05/image-whatsapp-Sheharyar-4.jpg',
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1627327053419-fe894c4650ed?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHNreSUyMHNjcmFwZXJzfGVufDB8fDB8fHww',
    'https://www.wheelhouseit.com/wp-content/uploads/2024/04/lawlap.jpeg',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1400&q=80',
  ],
};

function VideoPlayer({ service, language }) {
  const videoRef = useRef(null);
  const [videoError, setVideoError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) { v.play(); setIsPlaying(true); }
    else { v.pause(); setIsPlaying(false); }
  };

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setIsMuted(v.muted);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-headline font-bold text-primary text-center">{service.videoLabel}</h2>
      <div className="relative rounded-2xl overflow-hidden bg-primary/5 border border-outline-variant/20 shadow-lg group">
        {videoError ? (
          <div className="aspect-video flex flex-col items-center justify-center gap-4 bg-primary/5 p-8">
            <span className="material-symbols-outlined text-5xl text-secondary/40">videocam_off</span>
            <p className="text-on-surface/50 text-sm text-center">
              {language === 'ar'
                ? 'لم يتم تحميل الفيديو بعد. يُرجى إضافة ملف الفيديو الخاص بهذه الخدمة.'
                : 'Video not yet available. Please add the video file for this service.'}
            </p>
            <code className="text-xs text-secondary/60 bg-secondary/10 px-3 py-1.5 rounded-lg">
              {service.videoSrc}
            </code>
          </div>
        ) : (
          <>
            <video
              ref={videoRef}
              src={service.videoSrc}
              className="w-full aspect-video object-cover"
              onError={() => setVideoError(true)}
              onEnded={() => setIsPlaying(false)}
              onPause={() => setIsPlaying(false)}
              onPlay={() => setIsPlaying(true)}
              playsInline
              preload="metadata"
            />

            {/* Hover overlay */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20">
              <button
                type="button"
                onClick={togglePlay}
                className="w-16 h-16 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-xl transition-transform hover:scale-105"
                aria-label={isPlaying ? 'Pause' : 'Play'}
              >
                <span className="material-symbols-outlined text-primary text-3xl">
                  {isPlaying ? 'pause' : 'play_arrow'}
                </span>
              </button>
            </div>

            {/* Bottom controls */}
            <div className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-gradient-to-t from-black/60 to-transparent flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button type="button" onClick={togglePlay} className="text-white hover:text-secondary transition-colors" aria-label={isPlaying ? 'Pause' : 'Play'}>
                <span className="material-symbols-outlined text-xl">{isPlaying ? 'pause' : 'play_arrow'}</span>
              </button>
              <button type="button" onClick={toggleMute} className="text-white hover:text-secondary transition-colors" aria-label={isMuted ? 'Unmute' : 'Mute'}>
                <span className="material-symbols-outlined text-xl">{isMuted ? 'volume_off' : 'volume_up'}</span>
              </button>
            </div>

            {/* Static play button when paused */}
            {!isPlaying && (
              <button
                type="button"
                onClick={togglePlay}
                className="absolute inset-0 flex items-center justify-center group-hover:opacity-0 transition-opacity duration-300"
                aria-label="Play"
              >
                <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-xl">
                  <span className="material-symbols-outlined text-primary text-3xl">play_arrow</span>
                </div>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export function ServicePage({ slug }) {
  const { messages, t, toggleLanguage, language } = useLanguage();

  const slugs = messages.serviceSlugs;
  const index = slugs ? slugs.indexOf(slug) : -1;
  const service = messages.serviceDetails?.[index];
  const icon = messages.serviceIcons?.[index];
  const heroImage = serviceCardImages[index] ?? serviceCardImages[0];

  const hasCategories = Array.isArray(service?.categories) && service.categories.length > 0;
  const dir = language === 'ar' ? 'rtl' : 'ltr';

  if (!service) {
    return (
      <>
        <NavBar t={t} language={language} toggleLanguage={toggleLanguage} />
        <div className="min-h-screen flex items-center justify-center bg-surface-container-lowest">
          <div className="text-center space-y-6">
            <span className="material-symbols-outlined text-6xl text-secondary">search_off</span>
            <h1 className="text-3xl font-headline font-bold text-primary">{t('nav.services')}</h1>
            <p className="text-on-surface/60">{language === 'ar' ? 'الخدمة غير موجودة.' : 'Service not found.'}</p>
            <Link
              to="/#services"
              className="inline-flex items-center gap-2 px-6 py-3 bg-secondary text-white rounded-full font-semibold hover:bg-secondary/90 transition-colors"
            >
              <span className="material-symbols-outlined text-base">arrow_back</span>
              {language === 'ar' ? 'العودة إلى الخدمات' : 'Back to Services'}
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <NavBar t={t} language={language} toggleLanguage={toggleLanguage} />
      <div dir={dir} className="min-h-screen bg-surface-container-lowest">

        {/* Hero */}
        <section className="relative overflow-hidden min-h-[55vh] flex items-end">
          <img src={heroImage} alt={service.title} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/70 to-primary/30" />
          <div className="relative z-10 max-w-screen-xl mx-auto px-4 sm:px-8 pb-16 pt-32 w-full">
            <FadeIn>
              <Link
                to="/#services"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary text-white rounded-full font-semibold text-sm hover:bg-secondary/85 transition-colors mb-8 shadow-md"
              >
                <span className={`material-symbols-outlined text-base ${language === 'ar' ? 'rotate-180' : ''}`}>arrow_back</span>
                {language === 'ar' ? 'العودة إلى الخدمات' : 'Back to Services'}
              </Link>
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-secondary/90 rounded-xl">
                  <span className="material-symbols-outlined text-2xl text-white" aria-hidden="true">{icon}</span>
                </div>
                <span className="text-white font-bold uppercase tracking-widest text-lg">{service.subtitle}</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-headline font-bold text-white mb-4 leading-tight">
                {service.title}
              </h1>
              <p className="text-white/80 text-lg sm:text-xl max-w-2xl leading-relaxed">{service.heroDesc}</p>
            </FadeIn>
          </div>
        </section>

        {/* Intro + Video */}
        <section className="max-w-screen-xl mx-auto px-4 sm:px-8 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <div className="space-y-5 pt-6">
                {service.details.map((para, i) => (
                  <p key={i} className="text-on-surface/80 text-base sm:text-lg leading-relaxed">{para}</p>
                ))}

                {/* Simple highlights list — only shown when there are no categories */}
                {!hasCategories && service.highlights && (
                  <div className="pt-4">
                    <h2 className="text-xl font-headline font-bold text-primary mb-5">
                      {language === 'ar' ? 'ما نقدمه' : 'What We Offer'}
                    </h2>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {service.highlights.map((point, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-secondary/15 flex items-center justify-center">
                            <span className="material-symbols-outlined text-secondary" style={{ fontSize: '14px' }}>check</span>
                          </span>
                          <span className="text-on-surface/80 text-sm sm:text-base">{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </FadeIn>

            <FadeIn delay={120}>
              <VideoPlayer service={service} language={language} />
            </FadeIn>
          </div>
        </section>

        {/* Categories — zigzag layout */}
        {hasCategories && (
          <section className="bg-surface py-20 overflow-hidden">
            {/* Section heading */}
            <FadeIn>
              <div className="text-center max-w-2xl mx-auto px-4 mb-20 space-y-3">
                <h2 className="text-2xl font-bold text-secondary uppercase tracking-[0.25em]">
                  {language === 'ar' ? 'نادي حلول للاستشارات' : 'Holol Consulting Club'}
                </h2>
                <h3 className="text-3xl sm:text-4xl font-headline font-bold text-primary">
                  {language === 'ar' ? '٢٥ خدمة احترافية' : '25 Professional Services'}
                </h3>
                <p className="text-on-surface/60">
                  {language === 'ar'
                    ? 'تغطي كافة مراحل إنشاء المشروع، من الفكرة إلى التوسع أو التصفية'
                    : 'Covering every stage of your project creation — from inception to expansion or wind-down'}
                </p>
              </div>
            </FadeIn>

            {/* Zigzag rows */}
            <div>
              {service.categories.map((cat, ci) => {
                const reversed = ci % 2 !== 0;
                const catImgs = categoryImagesMap[slug] ?? categoryImagesMap.legal;
                const catImg = catImgs[ci] ?? catImgs[0];
                return (
                  <FadeIn key={ci}>
                    <div
                      className={`flex flex-col ${reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} min-h-[28rem] border-b border-outline-variant/10 last:border-b-0`}
                    >
                      {/* Image panel */}
                      <div className="relative w-full lg:w-1/2 min-h-72 lg:min-h-0 overflow-hidden">
                        <img
                          src={catImg}
                          alt={cat.title}
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                        />
                        {/* Gradient edge that bleeds into the text panel */}
                        <div
                          className={`absolute inset-0 ${
                            reversed
                              ? 'bg-gradient-to-l from-surface/60 via-transparent to-transparent'
                              : 'bg-gradient-to-r from-surface/60 via-transparent to-transparent'
                          }`}
                        />
                        {/* Number badge */}
                        <div className="absolute top-6 left-6 w-10 h-10 rounded-full bg-secondary flex items-center justify-center shadow-lg">
                          <span className="text-white font-bold text-sm">{String(ci + 1).padStart(2, '0')}</span>
                        </div>
                      </div>

                      {/* Text panel */}
                      <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 sm:px-14 py-14 bg-surface">
                        {/* Category title */}
                        <div className="flex items-center gap-3 mb-8">
                          <div className="p-2.5 bg-secondary/90 rounded-xl flex-shrink-0 shadow-sm">
                            <span className="material-symbols-outlined text-xl text-white" aria-hidden="true">
                              {cat.icon}
                            </span>
                          </div>
                          <h4 className="text-xl sm:text-2xl font-headline font-bold text-primary leading-tight">
                            {cat.title}
                          </h4>
                        </div>

                        {/* Services list */}
                        <ul className="space-y-5">
                          {cat.services.map((svc, si) => (
                            <li key={si} className="flex items-start gap-4 group/item">
                              <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-secondary/15 group-hover/item:bg-secondary/30 flex items-center justify-center transition-colors">
                                <span className="material-symbols-outlined text-secondary" style={{ fontSize: '12px' }}>
                                  check
                                </span>
                              </span>
                              <div>
                                <p className="font-semibold text-primary text-sm sm:text-base leading-snug">
                                  {svc.name}
                                </p>
                                <p className="text-on-surface/55 text-sm leading-relaxed mt-1">{svc.desc}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </FadeIn>
                );
              })}
            </div>
          </section>
        )}

        {/* Other services */}
        <section className={`py-16 ${hasCategories ? 'bg-surface-container-lowest' : 'bg-surface'}`}>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-8">
            <FadeIn>
              <h2 className="text-2xl font-headline font-bold text-primary mb-10">
                {language === 'ar' ? 'خدمات أخرى' : 'Other Services'}
              </h2>
            </FadeIn>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {messages.serviceDetails
                .map((s, i) => ({ ...s, i }))
                .filter(({ i }) => i !== index)
                .map(({ title, subtitle, i }) => (
                  <FadeIn key={i} delay={i * 60}>
                    <Link
                      to={`/services/${slugs[i]}`}
                      className="group relative flex items-end rounded-2xl overflow-hidden h-40 border border-outline-variant/20 hover:border-secondary/40 transition-colors"
                    >
                      <img
                        src={serviceCardImages[i]}
                        alt={title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-transparent" />
                      <div className="relative z-10 p-5 w-full">
                        <p className="text-secondary text-xs font-semibold uppercase tracking-wider mb-1">{subtitle}</p>
                        <p className="text-white font-bold leading-tight">{title}</p>
                      </div>
                    </Link>
                  </FadeIn>
                ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
